<template>
    <div class="ticketBooking orderDetails">
        <div class="ticketBooking-top"><i class="iconfont">&#xe632;</i>报名详情</div>
        <div class="ticketBookingBox" v-for="item in List" :key="item.id">
            <div v-if="item.Status===1">
                <div class="registrationDetails-top">
                    <div class="topLeft">{{item.title}}</div>
                    <div class="topRight">{{item.type}}</div>
                </div>
                <div class="registrationDetails-bottom">
                    <div class="bottom-top">
                        <div class="boxTop-lefts">{{item.name}}</div>
                        <div class="boxTop-right">预约数：{{item.number}}</div>
                    </div>
                    <div class="ticketBookingBox-boxTops">
                        <span class="text"><i class="iconfont">&#xe607;</i>参观日期：{{item.time}}</span>
                        <span class="boxBottom-text3" v-touch:tap="Twodimensionalcode()"><i class="iconfont">&#xe627;</i>电子二维码</span>
                    </div>
                </div>
            </div>   
            <div v-if="item.Status===2">
                <div class="registrationDetails-top">
                    <div class="topLeft">{{item.title}}</div>
                    <div class="topRights">{{item.type}}</div>
                </div>
                <div class="registrationDetails-bottom">
                    <div class="bottom-text">联 系 人：{{item.name}}</div>
                    <div class="bottom-text">手 机 号：{{item.photo}}</div>
                    <div class="bottom-text">身份证号：{{item.IDCard}}</div>
                    <div class="bottom-text">预约时间：{{item.time}}</div>
                </div>
            </div>            
        </div>
        <div class="notes">订单备注：{{notes}}</div>
        <div class="orderDetailsBox">
            <div class="orderDetailsBox-input">
                <van-field v-model="value" placeholder="请输入票号、游客姓名、证件号" />
                <div class="input-icon"><i class="iconfont">&#xe610;</i></div>
            </div>
            <div class="f-clear">
                <div class="btn-left">
                    <van-checkbox v-model="checked" icon-size="20px" v-touch:tap="allOfthem()">全选</van-checkbox>
                    <span class=""></span>
                </div>
                <div class="btn-right" v-touch:tap="cancels()">取消预约</div>
            </div>
        </div>
        <van-checkbox-group v-model="result" ref="checkboxGroup">
            <div class="orderDetailsBoxs f-m-t-sm" v-for="item in message" :key="item.id">
                <div class="orderDetailsBoxs-left">
                    <van-checkbox :name="item.index" icon-size="20px" v-touch:tap="obtain()"></van-checkbox>
                </div>
                <div class="orderDetailsBoxs-right">
                    <div class="f-clear">
                        <div class="right-text f-weight-500 f-left">{{item.name}}</div>
                        <div class="right-text f-right">身份证：{{item.IDCard}}</div>
                    </div>
                    <div class="f-clear f-p-t-sm" v-if="item.condition===1">
                        <div class="right-text f-left">票号：{{item.coding}}</div>
                        <div class="right-text f-right f-color-257EEA">{{item.type}}</div>
                    </div>
                    <div class="f-clear f-p-t-sm" v-if="item.condition===2">
                        <div class="right-text f-left">票号：{{item.coding}}</div>
                        <div class="right-text f-right">
                            <span class="f-color-E44141 f-size-12 f-p-r-md">{{item.Status}}</span>
                            <span class="f-color-27AF2D f-size-12">{{item.type}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-checkbox-group>
    </div>
</template>
<script>
import { Checkbox, CheckboxGroup,Field, Col} from 'vant';
export default {
    data(){
        return {
            List:[
                {
                    id:1,
                    time:"2019-11-20  09:00-12:00",
                    title:"博物馆门票",
                    type:"免费",
                    name:"免费",
                    number:5,
                    integral:100,
                    Status:1 ,//名称
                },
                {
                    id:2,
                    time:"2019-09-09 10：10：10",
                    title:"订单编号：65588800000",
                    type:"预约成功",
                    Status:2 ,//订单
                    name:"王某",
                    photo:"13000010001",
                    IDCard:"510101********0909",
                }
            ],
            notes:"无",
            value: '',
            checked: false,
            result: [],
            message:[
                {
                    id:1,
                    name:"游客1：王小二",
                    IDCard:"512363********620",
                    coding:"316066200005",
                    condition:1,
                    type:"已入馆",
                    index:0
                },
                {
                    id:2,
                    name:"游客2：王小二",
                    IDCard:"512363********620",
                    coding:"316066200005",
                    condition:2,
                    type:"未参观",
                    Status:"取消预约",
                    index:1
                },
                {
                    id:3,
                    name:"游客3：王小二",
                    IDCard:"512363********620",
                    coding:"316066200005",
                    condition:1,
                    type:"已入馆",
                    index:2
                },
            ]
        }
    },
    methods: {
        //电子二维码
        Twodimensionalcode() {
            return () => {
                // console.log(111);
            };
        },
        //全选
        allOfthem(){
            return () => {
                if(this.checked){
                   this.$refs.checkboxGroup.toggleAll();
                }else{
                   this.$refs.checkboxGroup.toggleAll(true);
                }
            }; 
        },
        //取消预约
         cancels(){
           return () => {
                // console.log(111);
            }; 
        },
        //获取选中id
        obtain(){
            return () => {
                if(this.result.length === 0){
                   console.log(1)
                }else{
                    console.log(this.result)
                }
            };
        }
    },
    components: {
        [Field.name]: Field,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    created() {
        
    },
}   
</script>

<style lang="less" scoped>
   .ticketBooking{
       background-color: #F1EFFB!important;
       padding: 20px 7px;
       .ticketBooking-top{
           padding: 0 17px;
           color: #606060;
           font-size: 14px;
           line-height:20px;
           .iconfont{
               color: #5A9BF6;
               padding-right: 6px;
               font-size: 18px;
           }
       }
       .ticketBookingBox{
           margin-top: 13px;
           background:rgba(255,255,255,1);
           border-radius:5px;
           padding: 0 8px;
           .registrationDetails-top{
               overflow: auto;
               zoom: 1;
               padding: 10px;
               border-bottom: 0.5px solid #D8D8D8;
               .topLeft{
                   float:left;
                   color: #606060;
                   font-size: 14px;
               }
               .topRight{
                   float:right;
                   color: #FF9E15;
                   font-size: 14px;
               }
               .topRights{
                   float:right;
                   color: #27AF2D;
                   font-size: 14px;
               }
           }
           .registrationDetails-bottom{
                padding: 10px;
                
                .bottom-top{
                    overflow: auto;
                    zoom: 1;
                    .boxTop-lefts{
                        line-height: 20px;
                        font-size: 14px;
                        color: #FF8D09;
                        font-weight:500;
                        float: left;
                    }
                    .boxTop-right{
                        line-height: 20px;
                        font-size: 14px;
                        color: #B3B3B3;
                        font-weight:500;
                        float: right;
                    }
                }
                .ticketBookingBox-boxTops{
                    // display: -webkit-flex;
                    // display: flex;
                    margin-top: 20px;
                    .text{
                        color: #606060;
                        font-size: 12px;
                        line-height: 20px;
                        // float: left;
                    }
                    .iconfont{
                        color: #5A9BF6;
                        padding-right: 10px;
                    }
                    .boxBottom-text3{
                        color: #606060;
                        font-size: 12px;
                        padding-left: 15px;
                        // text-align: right;
                        line-height: 20px;
                        .iconfont{
                            padding-right: 6px;
                        }
                    }
                }
                .bottom-text{
                    color: #8C8C8C;
                    font-size: 14px;
                    line-height:20px;
                    margin: 6px 0;
                }
           }
       }
       .notes{
           color: #606060;
           font-size: 14px;
           padding: 17px;
       }
       .orderDetailsBox{
           background:rgba(255,255,255,1);
           border-radius:5px;
           padding: 20px 10px 0 10px;
           .orderDetailsBox-input{
               position: relative;
               .van-cell{
                    background:rgba(255,255,255,1);
                    box-shadow:0px 6px 13px 0px rgba(235,229,238,1);
                    border-radius:18px;
                    border:0.5px solid rgba(232,232,232,1);
                    padding: 10px 20px 10px 50px;
                }
                .input-icon{
                    position: absolute;
                    left: 20px;
                    top: 12px;
                    .iconfont{
                        font-size: 20px;
                        color: #5A9BF6;
                    }
                }
                
           }
           .f-clear{
               zoom: 1;
               overflow: auto;
               padding: 20px 0;
               .btn-left{
                   float: left;
                   padding-top: 4px;
                   .van-checkbox__icon{
                       width: 18px;
                       height: 18px;
                   }
               }
               .btn-right{
                   height:28px; 
                   line-height: 28px;
                   width:91px;
                   text-align: center;
                   background:rgba(223,238,255,1); 
                   border-radius:13px;
                   color: #5CA2FD;
                   font-size: 14px;
                   cursor: pointer;
                   float:right;
               }
           }
       }
       .orderDetailsBoxs{
           background:rgba(255,255,255,1);
           border-radius:5px;
           padding: 20px 10px; 
           zoom: 1;
           overflow: auto;
           .orderDetailsBoxs-left{
               float: left;
               width: 30px;
           }
           .orderDetailsBoxs-right{
               margin-left: 30px;
               .right-text{
                   color: #606060;
                   font-size: 14px;
                   line-height: 20px;
               }
                .f-color-257EEA{
                    color: #257EEA;
                }
                .f-color-E44141{
                    color: #E44141;
                }
                .f-color-27AF2D{
                    color: #27AF2D;
                }
               .f-weight-500{
                   font-weight: 500;
               }
               .f-left{
                   float: left;
               }
               .f-right{
                   float: right;
               }
           }
       }
       .f-m-t-sm{ 
           margin-top: 10px; 
       }
       .van-checkbox__label{
           color: #606060;
           font-size: 14px!important;
       }
       .f-clear{
           zoom: 1;
           overflow: auto;
       }
       .f-p-t-sm{
           padding-top: 10px
       }
       .f-size-12{
           font-size: 12px;
       } 
       .f-p-r-md{
           padding-right: 20px;
       }
   }
  </style>